export default "/_next/static/images/2019-530009363e79d8d85edbb76e5597700f.svg";